import { render } from "./PerformanceManagement.vue?vue&type=template&id=cf68d8b0"
import script from "./PerformanceManagement.vue?vue&type=script&lang=js"
export * from "./PerformanceManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__